import { Enum } from './Enum'

export default {
  payTypeEnum: new Enum()
    .add('online', '在线支付', 'ONLINE')
    .add('prestorage', '预存款支付', 'PRE_STORAGE')
    .add('wechatPay', '微信支付', 'WECHAT_PAY'),
  orderStatusEnum: new Enum()
    .add('1', '待支付', 'UNPAY')
    .add('2', '审核中', 'VERIFYING')
    .add('3', '生产中', 'PRODUCTION')
    .add('4', '包装', 'PACKAGE')
    .add('5', '配送中', 'DELIVERYING')
    .add('6', '已送达', 'FINISH')
    .add('7', '已取消', 'CANCEL')
    .add('8', ' 审核通过', 'VERIFYED'),
  verifyStatusEnum: new Enum()
    .add('1', '未审核', 'VERIFYING')
    .add('2', ' 审核通过', 'SUCCESS')
    .add('3', '审核失败', 'FAIL')
    .add('4', '作废', 'CANCEL'),
  financeRecordTypeEnum: new Enum()
    .add('1', '充值', 'RECHARGE')
    .add('2', ' 售后', 'REFUND')
    .add('3', '支付', 'PAY')
    .add('4', '其他', 'OTHER'),
  authenticationTypeEnum: new Enum()
    .add('1', '品牌授权书', 'BRAND')
    .add('2', ' 商标注册书', 'TRADE_MARK')
    .add('3', '承印委托书', 'PROXY')
    .add('4', '品牌授权书/商标注册书', 'BRAND_TRADE_MARK'),
  // verifyStatusEnum: new Enum()
  //   .add('1', '未审核', 'VERIFYING')
  //   .add('2', '通过', 'SUCCESS')
  //   .add('3', '不通过', 'FAIL')
  //   .add('4', '作废', 'CANCEL'),
  refundStatusEnum: new Enum()
    .add('1', '待处理', 'VERIFY')
    .add('2', '处理中', 'VERIFYING')
    .add('3', '已处理', 'VERIFYED')
    .add('4', '驳回', 'REJECT')
    .add('5', '拒绝处理', 'REFUSE')
    .add('6', '处理完成', 'FINISH'),
  certificationStatusEnum: new Enum() 
    .add('1', '审核中', 'VERIFYING')
    .add('5', '审核失败', 'FAIL')
    .add('6', '审核成功', 'SUCCESS'),

}
